import React, { useEffect } from 'react';

import { Button } from '@infoods/lifebase-ui';
import AddRoundedIcon from '@mui/icons-material/AddRounded';

import classes from './EditResourceLibrary.module.scss';
import { VideoPageType } from '../../../constants/videoPage';
import {
  useVideosManagement,
  VideosManagementProvider,
} from './hooks/useVideosManagement';
import { VideosTable } from './VideosTable/VideosTable';
import { LbTabs, LbToggleTabsList } from '../../../../shared/components/tabs';
import { ResourceLibraryPageTitle } from '../ResourceLibraryPageTitle/ResourceLibraryPageTitle';

type EditResourceLibraryProps = {
  page: VideoPageType;
};

export const EditResourceLibrary = ({ page }: EditResourceLibraryProps) => {
  const videosManagement = useVideosManagement(page);
  const { selectedCategory, changeSelectedCategory, categoryOptions, openAddVideoModal } =
    videosManagement;

  useEffect(() => {
    videosManagement.getVideos();
  }, []);

  return (
    <VideosManagementProvider value={videosManagement}>
      <ResourceLibraryPageTitle page={page}>
        <Button
          variant="contained"
          size="medium"
          onClick={openAddVideoModal}
          startIcon={<AddRoundedIcon />}
        >
          Add New Video
        </Button>
      </ResourceLibraryPageTitle>
      {categoryOptions.length > 1 && (
        <LbTabs
          value={selectedCategory}
          onValueChange={changeSelectedCategory}
          className={classes.tabList}
        >
          <LbToggleTabsList size="small" tabsConfig={categoryOptions} />
        </LbTabs>
      )}
      <VideosTable />
    </VideosManagementProvider>
  );
};
